import { css } from 'aphrodite';
import * as React from 'react';
import { styleSheet } from '../styles';

interface IProps {
	name: string;
}

export const RuleName: React.FC<IProps> = ({ name }) => {
	return (
		<div className={css(styleSheet.name)} title={name}>
			{name}
		</div>
	);
};
